export enum CollectionItemType {
  Folder = 'folder',
  Resource = 'resource',
  Link = 'link',
}
